import { createSelector } from 'reselect';
import { RootState } from 'reducers/rootReducer';

const getProvidersReducer = (state: RootState) => state.providersReducer;

export const fullReducer = createSelector(getProvidersReducer, (res) => res);
export const advancedFilters = createSelector(getProvidersReducer, (res) => res.pageContext.filters.advanced);
export const pageContext = createSelector(getProvidersReducer, (res) => res.pageContext);
